<template>
  <div class="stations-page">
    <nav class="submenu">
      <ul>
        <li id="btn-1" @click.stop.prevent="colour(1)">
          <router-link to="/pos">
            <font-awesome-icon icon="fa-user-astronaut" size="2xl" />
            <p>POS</p>
          </router-link>
        </li>
        <li id="btn-2" @click.stop.prevent="colour(2)">
          <router-link to="/kds">
            <font-awesome-icon icon="fa-meteor" size="2xl" />
            <p>KDS</p>
          </router-link>
        </li>
				<li id="btn-3" @click.stop.prevent="colour(3)">
					<router-link to="/geo">
						<font-awesome-icon icon="fa-truck-fast" size="2xl" />
						<p>GEO</p>
					</router-link>
				</li>
        <li id="btn-4" @click.stop.prevent="colour(4)">
          <router-link to="/mon">
            <font-awesome-icon icon="fa-thermometer-half" size="2xl" />
            <p>MON</p>
          </router-link>
        </li>
        <!-- <li id="btn-3" @click.stop.prevent="colour(3)">
          <router-link to="/sat">
            <font-awesome-icon icon="fa-satellite" size="2xl" />
            <p>Satellite</p>
          </router-link>
        </li> -->
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "StationsPage",
  components: {},
  emits: ["close"],
  data() {
    return {};
  },
  mounted() {
    // Any initialization logic can go here
  },

  computed: {
    ...mapGetters({
      siteSetting: "siteSettings",
    }),
  },

  methods: {
    colour(id) {
      this.$emit("close");
      document.getElementById(`btn-${id}`).classList.add("router-link-active");
    },
  },
};
</script>

<style scoped lang="scss">
.stations-page {
  position: fixed;
  z-index: 999;
  top: 12%;
  translate: -40%;
  transition: all 500ms ease-in-out;
  //   scale: 0;

  .submenu {
    ul {
      box-shadow: var(--box-shadow);
      display: flex;
      flex-direction: column;
      list-style: none;
      background-color: var(--primary-colour);
      border: none;
      border-radius: 0.5rem;
      width: 4rem;
      padding: 1rem;
      margin: 1rem;
      gap: 2rem;
      align-items: center;
      li {
        margin-bottom: 1rem;
        p {
          text-decoration: none;
          font-size: 0.8rem;
          margin: 0;
        }
      }
      .router-link-active {
        color: var(--action-colour);
      }
    }
  }
}

@media only screen and (orientation: portrait) {
}
</style>
